<ng-container *ngIf="appModeService.isApp(); else webProfileFallback">
  <section class="app-profile-view">
    <header class="app-profile-header">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i *ngIf="!isRTL" class="bi bi-arrow-left"></i>
        <i *ngIf="isRTL" class="bi bi-arrow-right"></i>
      </button>
      <h1>{{ 'APP.NAV_PROFILE' | translate }}</h1>
      <span class="header-spacer" aria-hidden="true"></span>
    </header>

    <section class="app-profile-identity">
      <img [src]="profileImage" alt="Profile avatar" />
      <h2>{{ profileName }}</h2>
    </section>

    <section class="app-profile-content">
      <div class="profile-group">
        <h3>{{ 'PROFILE.ACCOUNT' | translate }}</h3>
        <div class="profile-list">
          <button type="button" class="profile-row" *ngFor="let item of accountItems" (click)="onMenuItemClick(item)">
            <span>{{ item.labelKey | translate }}</span>
            <i class="pi pi-angle-right"></i>
          </button>
        </div>
      </div>

      <div class="profile-group">
        <h3>{{ 'PROFILE.PREFERENCES' | translate }}</h3>
        <div class="profile-list">
          <button type="button" class="profile-row" *ngFor="let item of preferenceItems"
            (click)="onMenuItemClick(item)">
            <span>{{ item.labelKey | translate }}</span>
            <i class="pi pi-angle-right"></i>
          </button>
        </div>
      </div>

      <div class="profile-actions">
        <button type="button" class="logout-btn" (click)="onLogout()">
          {{ 'PROFILE.LOGOUT' | translate }}
        </button>
        <button type="button" class="delete-btn" (click)="onDeleteAccount()">
          {{ 'PROFILE.DELETE_ACCOUNT' | translate }}
        </button>
      </div>
    </section>
  </section>
</ng-container>

<ng-template #webProfileFallback>
  <div class="container py-5">
    <h1 class="main-title">{{ 'APP.NAV_PROFILE' | translate }}</h1>
    <p>{{ 'PROFILE.WEB_FALLBACK_MESSAGE' | translate }}</p>
  </div>
</ng-template>